import { AppDispatch } from '../store';
import { DBKnowledgebaseThunks } from './DBServiceThunks';
import { Knowledgebase } from '../../models/knowledgebase';
import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { JurisdictionCode } from '../../common/jurisdictions';

/**
 * Utility function to create a knowledge base for a case if it doesn't exist
 * This function is shared between case creation and failsafe mechanisms
 */
export const createKnowledgebaseForCase = async (
  dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
  caseId: string,
  ownerId: string,
  name: string,
  jurisdiction: JurisdictionCode,
  options?: {
    description?: string;
    throwOnError?: boolean;
    logPrefix?: string;
  }
): Promise<Knowledgebase | null> => {
  const { 
    description = `Knowledge base for ${name}`,
    throwOnError = false, 
    logPrefix = '[KnowledgebaseUtils]' 
  } = options || {};
  
  try {
    console.log(`${logPrefix} Creating knowledge base for case ${caseId} and owner ${ownerId}`);
    
    const knowledgebase: Partial<Knowledgebase> = {
      caseId: caseId,
      ownerId: ownerId,
      name: name,
      description: description,
      jurisdiction: jurisdiction
    };

    const createdKnowledgebase = await dispatch(DBKnowledgebaseThunks.create(knowledgebase as Knowledgebase)).unwrap();
    
    console.log(`${logPrefix} Successfully created knowledge base with ID: ${createdKnowledgebase._id}`);
    return createdKnowledgebase;
    
  } catch (error) {
    const errorMessage = `Failed to create knowledge base for case ${caseId}: ${error instanceof Error ? error.message : 'Unknown error'}`;
    console.error(`${logPrefix} ${errorMessage}`);
    
    if (throwOnError) {
      throw new Error(errorMessage);
    }
    
    return null;
  }
};
